﻿import { useEffect, FC, useState } from "react";
import { Box, BoxProps } from "@chakra-ui/react";
import { LoadingWidget } from "@am-tax/fe-core";

type PdfViewerProps = { pdfData?: Blob } & BoxProps;

export const PdfViewer: FC<PdfViewerProps> = ({ pdfData, ...boxProps }) => {
    const [pdfUrl, setPdfUrl] = useState<string>();
    useEffect(() => {
        if (pdfData) {
            setPdfUrl(URL.createObjectURL(pdfData));
        }
    }, [pdfData]);

    if (pdfUrl) {
        return (
            <Box {...boxProps}>
                {pdfUrl ? (
                    <iframe src={`/pdfjs-3.10.111-dist/web/wotc-viewer.html?file=${pdfUrl}&css=/custom-pdf-viewer.css`} width={"100%"} height={"100%"}></iframe>
                ) : (
                    <LoadingWidget />
                )}
            </Box>
        );
    } else {
        return null;
    }
};
